import React, { useContext } from "react";
import { MembershipContext } from "hoc/membership-data";
import styles from "./index.module.css";
import TeamCard from "components/teams/card";
import { useTranslation } from "react-i18next";

const TeamIndex = () => {
  const membershipData = useContext(MembershipContext);
  const { teams } = membershipData;
  const { t } = useTranslation();

  return (
    <div className="dashboard-container">
      <h1 className="title-1 mb-32">{t("teams.title")}</h1>
      <section className={styles.wrapper}>
        <div className={styles.content}>
          {teams.map((team, index) => (
            <TeamCard key={index} team={team} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default TeamIndex;
